

/* Below are the URL'S for the application, urls are sorted based on its module */

//Tenants URLS
export const Get_Tenant_List = '/api/tenants';
export const Get_Tenant_Names = '/api/tenantList';
export const get_Tenant_By_ID = '/api/tenants/';                                                         //This request returns the Tenant entity which has Id={tenantid}
                                                                                                         //This request returns the Tenant entity which has name={tenantname}
export const post_Tenant = '/api/tenants';                                                               //This POST request creates new Tenant in Tracer Ensemble.
export const edit_Tenant_Company_Info = '/api/tenants/';                                                 //This PUT request updates Company information of an existing Tenant entity in Tracer Ensemble.
export const edit_Tenant = '/api/tenants/';  
                                                                                                         //This PUT request updates After-hours billing details of an existing Tenant entity in Tracer Ensemble.
                       //This PUT request updates Normal Hours of an existing Tenant entity in Tracer Ensemble.
                                  //This DELETE request removes all selected input tenants{tenantIds} from Tracer Ensemble system.
export const licence_info = '/api/licenses/tenant';


//Tenant Employee
export const get_Tenant_Employees = '/api/tenant/employees';                                              //This request returns all Tenant employees created in Ensemble.
export const get_Tenant_Employees_By_ID = '/api/tenant/employees/';                         //This request returns the Tenant user which has Id={tenantuserid}                   //This request returns the Tenant user which has name={tenantusername}
export const post_Tenant_Employees = '/api/tenant/employees';                                             //This POST request creates new Tenant User in Tracer Ensemble under a Tenant entity.
export const put_Tenant_Employees = '/api/tenant/employees/';                               //This PUT request updates a Tenant User in Tracer Ensemble.
export const delete_Tenant_Employees = '/api/tenant/employees?removeDependents=false';                        //This DELETE request removes all selected input tenant users{tenantUserIds} from Tracer Ensemble system..

export const post_reportManagement_template = '/api/reportManagement/template';
//Zones                           //Facility Dummy API                          
export const get_Zones = '/api/tenant/zones';                                                             //get list of Zones
export const get_Zone_By_ID = '/api/tenants/';                              //get Zone by ID
export const post_Zone = '/api/tenant/zones';                                                             //POST Zone method
export const put_Zone = '/api/tenant/zones/';                                                             //PUT Zone method
export const delete_Zones = '/api/tenant/zones';  
export const get_employee_Zones = '/api/tenant/employees/zones';   
export const get_employee_Requests = '/api/tenant/employees/requests';                                                     //Delete single or multiple Zone method


//Holidays
export const get_Holidays = '/api/tenant/holidays';
export const get_Holiday_By_ID = '/api/tenant/holidays/';
export const get_Add_Holiday = '/api/tenant/holidays/';
export const put_Edit_Holiday = '/api/tenant/holidays/'; 
export const delete_Holidays = '/api/tenant/holidays';  


//Facility Requests
export const get_Temperature_adjustments_list = '/api/tenant/zones/temperature'; 

export const get_Temperature_widget_details = '/api/tenant/zones/';  
export const get_employee_MyRequests = '/api/employees/workOrders';  
export const get_employee_AllRequests = '/api/employees/AllworkOrders';  


//Buildings
export const get_Buildings_List = '/api/buildings/';                                                      //get list of Buildings
export const get_Building_Members_List = '/api/buildings/';                                                //get list of Building members list
export const get_Buildings_Details_List = '/api/tenant/holidays/AllBuildings';  
export const get_Family_Types = '/api/buildings/';
export const get_Family_Types_Second_Part = '/family';


//get list of Building members list
                   //get list of Building members family list


//Tenant Meters
export const get_Tenant_Meters = '/api/tenants/meter/';
export const save_Tenant_Meter = '/api/tenants/';
export const get_Datalog_Value = '/api/datalog/';
export const get_Datalog_Meters = '/api/meters';


//Temperature                               //Retrieve all zones which are enabled for Temperature adjustment by having one space/area as member


//Employee 
export const get_EmployeeRegularExpressions = '/api/credentials/regularExpression';

//Synchronize Database
export const synchronize_database = '/api/buildings/synchronize';
//User Preferences
export const user_preferences = '/api/user/preferences'; 
export const edit_user_preferences = '/api/users/'
export const user_details_after_login = '/api/user'; 
export const post_eula_acceptance = '/api/user/eula';
export const post_user_transaction = '/api/logontransaction'; 

//Requests
export const post_Request = '/api/tenant/requests';
export const get_Request = '/api/tenant/requests';
export const get_Cost = '/api/tenant/request/cost';
export const get_PastRequest = '/api/tenant/pastrequests';

//Invoices
export const post_Tenant_Invoice_Details = '/api/tenant/previewInvoice';
export const get_Tenant_AfterHours = '/invoice/afterHours';
export const Invoice_Template = '/api/tenant/invoice/template';
export const Invoice_logo = '/api/tenant/invoice/logo';
export const get_generated_invoice = '/api/tenant/invoices';
export const send_invoice_email = '/api/tenant/invoices/mail';
export const Generate_Invoice = '/api/tenant/invoice';
export const Generate_Invoice_Excel = '/api/tenant/invoiceexcel';
export const Generate_Summary_Invoice = '/api/tenant/invoicesummary';
export const Generate_Excel_Summary_Invoice = '/api/tenant/invoicesummaryexcel';
export const Facility_logo = '/api/tenant/logo';
export const Facility_background_image = '/api/tenant/image';
export const Facility_Image = '/api/tenant/facility/image';
export const Restore_Facility_Image = '/api/tenant/facility/Restoreimage'; 
export const Delete_Facility_Logo = '/api/tenant/facility/DeleteImage';

//Administration
export const get_all_discovery_requests= '/api/buildings/discovery';
export const get_all_discovered= '/api/buildings/discovered';
export const delete_installed_buildings = '/api/buildings';
export const get_all_buildings = '/api/buildingslist';
export const get_all_buildingslist = '/api/allbuildingslist';
export const get_server_id = '/api/license/server/';
export const save_license_request = '/api/license';
export const upload_License_File = '/api/license/';
export const get_license_information = '/api/license/licenseInformation';
export const get_tenant_workorder_licenseinfo = '/api/license/features';
export const get_license_customer_information = '/api/license/licenseCustomerInformation';
export const get_all_buildings_timezone = '/api/buildings/timeZones';
export const get_Bacnet_Building = '/api/logicalBuilding';
// export const get_feature_license = '/api/license/features';
export const get_userchange_log = '/api/userLogs';
export const get_application_version = '/api/version';
export const get_user_role_permission = '/api/user/role/permission/application';
export const get_user_role_permission_workorder = '/api/user/role/workorderpermission/application';
export const get_product_fullversion = '/api/fullVersion';
export const get_db_version = '/api/dbVersion';
export const get_license_info = '/api/license/amplitude/licenseInformation';
export const get_instance_type = '/api/license/InstanceType';
export const get_device_panel_details = '/api/license/panel';
export const activate_license_panel = '/api/license/panel/activate';
export const deactivate_license_panel = '/api/license/panel/deactivate';
export const update_license_cache = '/api/license/refresh';

//Create Users
export const get_user_role = '/api/user/roles';
export const save_user_details = '/api/users';
export const get_user_list = '/api/users';
export const set_reset_password = '/api/user/reset_password';

//Workorder
export const get_WorkorderList = '/api/workOrders';
export const get_ClosedWorkorderList = '/api/ClosedworkOrders';
export const get_Equipment_WorkorderList = '/api/workOrders/equipment';
export const get_Workorderbuildings = '/api/workOrder/buildings';
export const get_WorkorderbuildingsEquipments = '/api/buildings/equipment';
export const get_PMbuildingsEquipments = '/api/preventativeMaintenance/buildings/equipments';
export const post_WorkOrderAttachment = '/api/workOrder/attachments';
export const post_WorkOrderAttachmentToFolder = '/api/workOrder/attachment';
export const post_WorkOrder = '/api/workOrders';
export const post_WorkOrder_Form = "/api/workOrders/workOrderForm";
export const post_WorkOrderAttachment_Form = '/api/workOrders/workOrderForm/attachments';
export const get_WorkOrder_Form_sitekey = "/api/workOrders/workOrderForm/SiteKey";
export const post_WorkOrder_Form_Log = "/api/workOrders/workOrderForm/log";
export const get_WorkOrder_Form_Access= "/api/workOrders/workOrderForm/access";
export const post_WorkOrderBuilding = '/api/workOrder/buildings';
export const delete_Workorder = '/api/workOrders';
export const get_Technician = '/api/workOrder/technicians';
export const download_Attachmnet = '/api/attachment';
export const delete_Workorder_Building = '/api/workOrder/buildings/';
export const get_WorkOrderStandardField = '/api/workOrder/standardFields';
export const add_WorkOrderStandardField = '/api/workOrder/standardFields';
export const put_tenantassociation = '/api/tenant/buildingMappings';
export const get_PrevenatativeMaintenanceStandardField = '/api/workOrder/preventativeMaintenance/standardFields';
export const add_PrevenatativeMaintenanceStandardField = '/api/workOrder/preventativeMaintenance/standardFields';
export const post_WorkOrderEquipment = '/api/workOrder/equipments';
export const get_WorkorderEquipments = '/api/workOrder/equipments';
export const get_ServerTime = '/api/workOrder/serverTime';
export const post_WorkOrder_Tenant = '/api/workOrder/tenant';
export const get_MailSetting = '/api/workOrder/mailsetting';
export const post_WOSetup_MailAddress = '/api/workOrder/setup/email';
export const get_WOForm_CustomFields = '/api/workOrders/workOrderForm/customFields';
export const get_WOForm_TenantLists = '../api/workOrders/workOrderForm/tenants';

//WorkOrderReport
export const get_AllWorkOrderReports = '/api/workOrders/reportList';
export const generate_WOReports_PDF = '/api/workOrders/report/woreports/pdf';
export const generate_WOReports_XLS = '/api/workOrders/report/woreports/excel';
export const delete_WorkOrderReports = '/api/workOrder/reports';

// Login Attempts ReportGenerator
export const generate_loginAttempt_PDF ='../api/invalidLoginDetails/report/pdf';
export const generate_loginAttempt_XLS ='../api/invalidLoginDetails/report/excel';

//BacnetServices
export const post_SecureConnect = '/api/hub/secure-networks';
export const get_ConfigValue = '/api/hub/external-hub-uri';
export const get_NetworkList='/api/hub/secure-networks';
export const post_CertificateFile='/api/hub/certificates-authority/signing-request';
export const get_CertificateList='/api/hub/signed-certificates';
export const get_NetworkDetailList='/api/hub/secure-network-details';
export const get_generated_certificate='/api/hub/signed-certificates';
export const get_hub_parameter_details='/api/hub';
export const update_hub_parameter_details='/api/hub';
export const get_root_cert_details='/api/hub/root-certificate';
export const get_issuer_cert_details='/api/hub/issuer-certificate';
export const get_operational_cert_details='/api/hub/operational-certificate';
export const download_root_certificate='/api/hub/certificates/root';
export const generate_new_csr_certificate='/api/hub/csr';
export const upload_root_certificate='/api/hub/root-certificate-configure';
export const upload_operational_certificate='/api/hub/operational-certificate-configure';
export const get_hub_server_status='/api/hub/status';
export const delete_secure_network_link='/api/hub/secure-networks';
export const delete_operational_certificate='/api/hub/signed-certificates';
export const post_secure_network_link='/api/hub/secure-network-configuration';
export const update_secure_network_link='/api/hub/update-network-configuration';
export const test_secure_network_link='/api/hub/InitializeTestConnection';
export const test_secure_network_link_status='/api/hub/TestConnectionStatus';
export const update_secure_connect_settings='/api/hub/secure-connect-settings';
export const secure_connect_networkPort = '/api/hub/secure-connect-add-networkPort';
export const secure_connect_updatenetworkPort = '/api/hub/secure-connect-update-networkPort';

//PreventativeMaintenance
export const post_PreventativeMaintenance = '/api/workOrder/preventativeMaintenances';
export const get_PreventativeMaintenanceList = '/api/workOrder/preventativeMaintenances';
export const get_ClosedPreventativeMaintenanceList = '/api/workOrder/ClosedPreventativeMaintenances';
export const post_PreventativeMaintenances = '/api/preventativeMaintenance';
export const post_PreventativeMaintenanceTemplate = '/api/workOrder/preventativeMaintenance/template';
export const delete_PreventativeMaintenanceTemplate = '/api/workOrder/preventativeMaintenance/template';
export const get_IndividualPreventativeMaintenanceTemplate = '/api/workOrder/preventativeMaintenance/templates';
export const Copy_Attachments = '/api/workOrder/preventativeMaintenance/template/attachment';
export const post_PMSetup_MailAddress = '/api/workOrder/preventativeMaintenance/setup/email';
export const get_ServiceRequestSetupDetails = '/api/workOrder/getServiceRequestSetupDetails';
export const post_ServiceRequestSetupDetails = '/api/workOrder/serviceRequest';

//Password System
export const password_policy = '/api/user/policy/password';    //Checks password Policy


/*DashBoard API's (Data Visualisation) */

export const Dashboards_list = '/api/Dashboards';
export const get_dashboard = '/api/dashboard/';
/*DashBoard API's (Data Visualisation) */

export const get_zone_timezone = '/api/tenant/zones/timeZone';

/*Reports Management System API's (Data Visualisation) */
export const get_reportsList = '/api/reportmanagement/reports';
export const get_reportsHistoryList = '/api/reportmanagement/report/';
export const get_reportsTemplates = '/api/reportManagement/report/template/';
export const get_reportPeriods = '/api/datavsz/getReportPeriods';
export const get_identifierData = '/api/datavsz/getdata';
export const get_identifierData_multiple = '/api/datavsz/getdata/multiple';
export const post_reportDefinition = '/api/reportmanagement/report/definition';
export const put_reportDefinition = '/api/reportmanagement/report/';
export const get_buildings = '/api/datavsz/dataPoints/buildings';
export const get_logs = '/api/datavsz/logs/';
export const get_imagePath = '/api/reportmanagement/image/';
export const get_generated_report = '/api/reportmanagement/download';
export const delete_artifacts = '/api/reportmanagement/artifacts/';

//Data export APIs
export const get_All_Buildings = '/api/reportManagement/buildings'
export const get_All_Family_Types = '/api/familyTypes/';
export const get_Buildings_FamilyTypes_Equipment = '/api/buildings/familyTypes/equipment';
export const get_Equipment_Properties = '/api/controllers/properties';
export const get_DatalogDefinitions = '/api/reportManagement/datalogDefinitions';
export const post_Export_Without_Schedule = '/api/ReportManagement/dataExport';
export const put_Export_Without_Schedule = '/api/ReportManagement/dataExport/';
export const get_Export_DataSource = '/api/reportmanagement/report/';

//Trane Connect User API's
export const post_trane_user = '/api/traneConnect/userAccounts';
export const put_trane_user = '/api/traneConnect/userAccount';
export const Site_User_Accounts = '/api/sites/userAccounts';
export const Site = '/api/sites/';

//Custom Fields
export const get_WorkOrderCustomFields = '/api/workOrder/customFields';
export const post_custom_Field = '/api/workOrder/customFields';
export const Update_Custom_Field = '/api/workOrder/customFields';
export const Update_PM_Custom_Field = '/api/workOrder/preventativeMaintenance/customFields';
export const delete_CustomField = '/api/workOrder/customFields';
export const delete_CustomFieldValue = '/api/workOrder/customFieldsValue';
export const delete_PM_CustomFieldValue = '/api/workOrder/preventativeMaintenance/customFieldsValue';
export const get_PreventativeMaintenanceCustomFields = '/api/workOrder/preventativeMaintenance/customFields';
export const post_PreventativeMaintenanceCustomFields = '/api/workOrder/preventativeMaintenance/customFields';
export const get_PreventativeMaintenanceTemplates = '/api/workOrder/preventativeMaintenance/templates';

//ASU Related URLs
export const get_AllCampusInvoices = '/api/BillingInvoices/invoices/';
export const get_CampusMonthlyCharges = '/api/BillingInvoices/monthlyCharges';
export const get_AllCampusInvoicesFilter = '/api/BillingInvoices/invoices/filters';
export const get_CampusBuildingInvoiceByBuildingId =  '/api/BillingInvoices/invoices/';
export const get_BillingCalculation = '/api/BillingInvoices/calculationDiagram';
export const get_BuildingInvoiceExcel = '/api/BillingInvoices/invoices/buildinginvoice/excel';
export const Generate_ASU_Summary_Invoice = '/api/BillingInvoices/invoices/BuildingInvoice/pdf';

//WorkOrder Reports
export const post_WorkOrderReport = '/api/workOrders/report';

//Schedules
export const get_Schedules_Recurrence_List = '/api/reportManagement/report/';
export const put_Schedules_Recurrence_List = '/api/reportManagement/report/scheduleDetails';

//Left Navigation


//Event Marker
export const get_Eventmarker_List = '/api/eventmarker/list';
export const get_EventMarkerType_List = '/api/eventmarker/types';
export const delete_EventMarker = '/api/eventMarker/';
export const post_EventMarker = '/api/eventmarker/details'
export const post_EventMarkerType = '/api/eventmarker/type/details'
export const get_Attachment = '/api/eventMarker/download/';

// Invalid Login 
export const get_invalid_login = '/api/invalidLoginDetails';

//Dashboard
export const get_Dashboard_List='/api/datavsz/dashboards'
export const delete_Dashboard='/api/datavsz/dashboard'
export const get_Dashboard = '/api/datavsz/dashboard';

//Attachments
export const put_Attachments='/api/eventMarker/attachment';
// Edit files\
export const edit_files = '/api/eventMarker/files';

//Summary
export const getChillerSequence = '/api/equipment';
export const update_chiller_sequence = "/api/building/chiller-plant/chiller-sequence";

//Equipment List
export const getBuildings = '/api/allbuildingslist';
export const getFamilyTypes = '/api/buildings';
export const getEquipmentsRowData = '/api/buildings/controller';
export const getEquipmentDisplayId = '/api/datavsz/propertyTableData';
export const getResponsePoint = '/api/buildings/siteId/family/familyType/point';
